<template>
    <div class="home container">

        <div class="sidebar">
            <NavItem :activeSection="activeSection" v-for="item in navList" :key="item.id" :item="item" :level="0"
                @navigate="scrollToSection" />
            <!-- <div>
                <div :class="{ active: activeSection === item.id }" v-for="(item, index) in navList" :key="item.id">
                    <div @click="scrollToSection(item.id)">{{ item.title + index }}</div>

                </div>
            </div> -->
        </div>

        <!-- 右侧内容 -->
        <div class="content">
            <h1 id="0"><strong>星河智联个人信息保护政策V1.0</strong></h1>
            <h3 id="0.1"><strong>尊敬的用户：</strong></h3>
            <p>您正在注册、登录或使用的车载智能座舱内的软件、APP（以下统称“系统”），由【星河智联汽车科技有限公司】（以下简称“我们”或“我司”）提供智能座舱相关技术服务（以下简称“SyncoreOS服务”）。我们深知个人信息安全与隐私保护对您的重要性，并始终秉持合法、正当、必要和诚信的原则处理您的个人信息，并竭力为您的个人信息安全提供充分保障。
            </p>
            <p>本《个人信息保护政策》（以下简称“本政策”）旨在向您清晰说明：</p>
            <ul>
                <li style="text-align: left;">我们如何收集、使用、存储、共享和保护您的个人信息；</li>
                <li style="text-align: left;">您享有的权利及行使方式；</li>
                <li style="text-align: left;">我们的合规承诺与责任边界。</li>
                <li style="text-align: left;">请您在使用我们的服务前，仔细阅读并充分理解本政策内容。如您有任何疑问，可通过文末联系方式与我们联系。</li>
                <li style="text-align: left;">鉴于本公司可能并不与您存在直接合同关系，我们已经要求车企通过系统的隐私政策或服务协议等适当的方式使您知晓其已经集成了 SyncoreOS
                    服务的功能模块或正在使用 SyncoreOS 服务，并要求车企确保您知悉且同意系统获取和使用您的相关信息的权利延展至本公司，使本公司可以获取和使用实现 SyncoreOS 服务所必要的合理信息。</li>
                <li style="text-align: left;">尽管如此，本公司亦希望通过本隐私政策帮助您了解我们在提供 SyncoreOS
                    服务过程中是如何收集、使用、共享、转让、公开披露、保护您的用户信息，同时向您披露我们收集和使用用户信息的目的、方式、范围，为您提供访问、更新、删除用户信息的方法。</li>
                <li style="text-align: left;">
                    <strong>特别提示</strong>：我们不会以“您下载、安装、登录或使用系统”作为默认同意本政策的依据。您在首次使用涉及数据共享功能时，将通过车机系统获得单独提示。若您选择开启“向我司共享数据”开关，则表示您已阅读并理解本政策，并自愿授权我们处理您的个人信息以提供服务。如果您不同意本条款的内容，请关闭该开关或联系车企进行进一步操作。
                </li>
                <li style="text-align: left;"></li>
            </ul>
            <div style="margin-top: 45px;"></div>
            <hr />
            <p><br></p>
            <h1 id="1"><strong>一、我们是谁</strong></h1>
            <p>星河智联汽车科技有限公司是由科大讯飞和广汽集团共同携手成立的面向智能网联领域的创新型科技企业。 我们致力于在智能座舱、车联网及数字化服务等领域，打造品牌、技术和产品体验领先的行业标杆与全场景出行服务智能化解决方案。
            </p>
            <ul>
                <li style="text-align: left;">公司名称：星河智联汽车科技有限公司</li>
                <li style="text-align: left;">注册地址：广州市南沙区望江二街4号701房01室、701房02室、701房03室、701房04室、701房05室</li>
                <li style="text-align: left;">办公地址：广东省广州市海珠区琶洲大道79-87号宝地广场22楼（研发运营中心）</li>
                <li style="text-align: left;">联系电话：(0551) 6515 7417（工作日 9:00–18:00）</li>
                <li style="text-align: left;">官网地址：https://www.syncore.space</li>
                <li style="text-align: left;">用户权益事务邮箱：privacy@syncore.space</li>
                <li style="text-align: left;">个人信息保护负责人邮箱：dpo@syncore.space</li>
                <li style="text-align: left;"><br></li>
            </ul>
            <h1 id="2"><strong>二、我们如何收集和使用您的个人信息</strong></h1>
            <h2 id="2.1"><strong>2.1 个人信息收集说明</strong></h2>
            <p>我们仅会出于提供 SyncoreOS
                服务的需要，在我们已获得您充分授权的情况下，在服务必需的范围内，通过软件工具开发包（SDK）等方式收集和使用您的用户信息。所有数据处理均遵循合法、正当、必要和诚信原则，并严格控制在实现服务目的所必需的最小范围内。
            </p>
            <p>根据具体的智能座舱应用场景，您可能会被收集到以下类型的个人信息：</p>
            <p><br></p>
            <table style="width: auto;">
                <tbody>
                    <tr>
                        <th colspan="1" rowspan="1" width="auto" style="text-align: left;">收集的个人信息类型</th>
                        <th colspan="1" rowspan="1" width="auto" style="text-align: left;">具体字段示例</th>
                        <th colspan="1" rowspan="1" width="auto" style="text-align: left;">使用目的</th>
                    </tr>
                    <tr>
                        <td colSpan="1" rowSpan="1" width="auto">设备标识信息</td>
                        <td colSpan="1" rowSpan="1" width="auto">设备唯一标识、客户端系统版本号、系统版本号、客户端应用版本号、数据收集协议版本号</td>
                        <td colSpan="1" rowSpan="1" width="auto">用于设备识别、兼容性适配、故障排查与技术支持</td>
                    </tr>
                    <tr>
                        <td colSpan="1" rowSpan="1" width="auto">用户账户信息</td>
                        <td colSpan="1" rowSpan="1" width="auto">用户唯一标识、广汽账号ID</td>
                        <td colSpan="1" rowSpan="1" width="auto">用于用户身份识别、服务绑定与个性化功能实现</td>
                    </tr>
                    <tr>
                        <td colSpan="1" rowSpan="1" width="auto">位置信息</td>
                        <td colSpan="1" rowSpan="1" width="auto">经度、纬度、GPS时间戳、省份、城市、区、街道、详细地址、POI名称、地址描述</td>
                        <td colSpan="1" rowSpan="1" width="auto">用于导航目的地推荐、个性化路线记忆、场景化服务触发（如恶劣天气提醒等）、位置相关语音交互等功能实现</td>
                    </tr>
                    <tr>
                        <td colSpan="1" rowSpan="1" width="auto">车辆运行状态信息</td>
                        <td colSpan="1" rowSpan="1" width="auto">车辆启动状态、车型配置、发动机类型、变速箱类型、车辆驱动类型、外置功放配置、上网方式</td>
                        <td colSpan="1" rowSpan="1" width="auto">用于服务适配（如音效调节）、语音交互上下文理解（如用车帮助问答）等功能实现</td>
                    </tr>
                    <tr>
                        <td colSpan="1" rowSpan="1" width="auto">应用行为信息</td>
                        <td colSpan="1" rowSpan="1" width="auto">应用ID、应用名、app版本号、事件时间戳、事件类型、操作页面、页面位置、事件产生的属性、事件名称</td>
                        <td colSpan="1" rowSpan="1" width="auto">用于分析用户使用习惯、优化交互逻辑、提升产品体验<br><br></td>
                    </tr>
                </tbody>
            </table>
            <h3 id="2.1.1">2.1.1 补充说明</h3>
            <ol>
                <li style="text-align: left;">1.数据来源说明：所有个人信息均由车厂与我们在取得用户授权后依法共享。</li>
                <li style="text-align: left;">
                    2.使用目的说明：
                </li>
                <li>
                    &nbsp;&nbsp;&nbsp;所有数据仅用于实现以下目的：
                </li>
                <li>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;提供语音交互、智能推荐等核心功能；
                </li>
                <li>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;优化产品性能与用户体验；
                </li>
                <li>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;进行系统稳定性监测与问题修复；
                </li>
                <li>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;满足法律法规规定的安全审计与合规要求。
                </li>
                <ul>&nbsp;&nbsp;&nbsp;我们在内容推荐中会基于使用习惯进行模型计算，但不会仅通过自动化决策作出对您权益有重大影响的决定（如限制服务）。您可随时关闭个性化推荐功能。</ul>
            </ol>
            <h3>2.1.2 用户权利提示</h3>
            <p>您有权通过车机系统的【设置】&gt;【隐私】的“数据共享”开关，随时<strong>开启或关闭</strong>向我司的数据共享。一旦关闭，我们将立即停止数据接收，并在24小时内清除本地缓存数据。</p>
            <p><br></p>
            <h2 id="2.2">2.2 设备权限获取说明</h2>
            <p>我们未直接申请设备权限，所有权限由系统基于功能需求调用。若涉及以下权限，其用途如下：</p>
            <p><br></p>
            <table style="width: auto;">
                <tbody>
                    <tr>
                        <th colspan="1" rowspan="1" width="auto" style="text-align: left;">权限</th>
                        <th colspan="1" rowspan="1" width="auto" style="text-align: left;">用途</th>
                        <th colspan="1" rowspan="1" width="auto" style="text-align: left;">是否必需</th>
                        <th colspan="1" rowspan="1" width="auto" style="text-align: left;">权限</th>
                    </tr>
                    <tr>
                        <td colSpan="1" rowSpan="1" width="auto">android.permission.ACCESS_NETWORK_STATE</td>
                        <td colSpan="1" rowSpan="1" width="auto">检测联网方式，在网络异常状态下避免数据发送，节省流量和电量。</td>
                        <td colSpan="1" rowSpan="1" width="auto">必需权限</td>
                        <td colSpan="1" rowSpan="1" width="auto">数据分析时需要申请，例如在不同网络状态下上报相关数据</td>
                    </tr>
                    <tr>
                        <td colSpan="1" rowSpan="1" width="auto">android.permission.INTERNET</td>
                        <td colSpan="1" rowSpan="1" width="auto">允许应用程序联网和发送统计数据的权限，以便提供统计分析服务。</td>
                        <td colSpan="1" rowSpan="1" width="auto">必需权限</td>
                        <td colSpan="1" rowSpan="1" width="auto">数据分析时需要申请，例如上报相关数据</td>
                    </tr>
                    <tr>
                        <td colSpan="1" rowSpan="1" width="auto">android.permission.ACCESS_WIFI_STATE</td>
                        <td colSpan="1" rowSpan="1" width="auto">获取WIFI网络类型，检测联网方式，节省流量和电量。</td>
                        <td colSpan="1" rowSpan="1" width="auto">必需权限</td>
                        <td colSpan="1" rowSpan="1" width="auto">数据分析时需要申请，例如在不同网络状态下上报相关数据</td>
                    </tr>
                    <tr>
                        <td colSpan="1" rowSpan="1" width="auto">android.permission.CHANGE_WIFI_STATE</td>
                        <td colSpan="1" rowSpan="1" width="auto">监控WIFI网络变化，用于判断是否处于无网环境</td>
                        <td colSpan="1" rowSpan="1" width="auto">必需权限</td>
                        <td colSpan="1" rowSpan="1" width="auto">数据分析时需要申请，例如上报相关数据</td>
                    </tr>
                    <tr>
                        <td colSpan="1" rowSpan="1" width="auto">android.permission.READ_LOGS</td>
                        <td colSpan="1" rowSpan="1" width="auto">读取系统日志</td>
                        <td colSpan="1" rowSpan="1" width="auto">必需权限</td>
                        <td colSpan="1" rowSpan="1" width="auto">需要读取日志，用于分析数据时<br><br></td>
                    </tr>
                </tbody>
            </table>
            <h1 id="3"><strong>三、我们如何存储您的个人信息</strong></h1>
            <h2 id="3.1">3.1 存储方式和期限</h2>
            <p>3.1.1 我们会通过加密数据库和服务器日志等安全的方式存储您的信息。</p>
            <p>3.1.2 我们只会在为实现SyncoreOS服务目的所必需的时间内或法律法规规定的条件下存储您的个人信息。除非适用法律要求或车企要求保存更长时间，存储期限如下表所示：</p>
            <p><br></p>
            <table style="width: auto;">
                <tbody>
                    <tr>
                        <th colspan="1" rowspan="1" width="auto" style="text-align: left;">数据类型</th>
                        <th colspan="1" rowspan="1" width="auto" style="text-align: left;">最长存储周期</th>
                        <th colspan="1" rowspan="1" width="auto" style="text-align: left;">清除机制</th>
                    </tr>
                    <tr>
                        <td colSpan="1" rowSpan="1" width="auto">敏感个人信息（位置、用户ID、语音文本等）</td>
                        <td colSpan="1" rowSpan="1" width="auto">90天</td>
                        <td colSpan="1" rowSpan="1" width="auto">到期自动删除，不可恢复</td>
                    </tr>
                    <tr>
                        <td colSpan="1" rowSpan="1" width="auto">一般个人信息（设备标识、行为日志等）</td>
                        <td colSpan="1" rowSpan="1" width="auto">180天</td>
                        <td colSpan="1" rowSpan="1" width="auto">可配置清除策略</td>
                    </tr>
                    <tr>
                        <td colSpan="1" rowSpan="1" width="auto">匿名化/聚合数据</td>
                        <td colSpan="1" rowSpan="1" width="auto">≤2年</td>
                        <td colSpan="1" rowSpan="1" width="auto">
                            用于产品迭代分析<br>（3）您的个人信息可能存在备份数据，但仅用于解决争议、维护系统安全或防灾目的。我们将采取物理或逻辑隔离措施，确保备份数据无法被常规业务系统访问；任何调用均需经安全负责人审批，并记录操作日志。
                        </td>
                    </tr>
                </tbody>
            </table>
            <h2 id="3.2">3.2 存储地域</h2>
            <p>3.2.1 所有个人信息均存储于中华人民共和国境内（安徽合肥数据中心），无跨境传输。</p>
            <p>3.2.2 如果未来需要跨境传输或存储您的个人信息，我们会提前告知您信息出境的目的、接收方、安全保证措施和安全风险，并另行取得您的明确授权。</p>
            <h1 id="4"><strong>四、我们如何共享、转让、公开您的个人信息</strong></h1>
            <p><strong>我们不会主动向第三方提供、转让、共享或披露您的信息，</strong>除非满足以下任一情形：</p>
            <p>（1）获取您的单独同意；</p>
            <p>（2）为履行法定职责或配合司法机关调查，且符合法律规定；</p>
            <p>（3）为维护国家安全、公共利益所必需；</p>
            <p>（4）向我们的授权合作方提供、转让、共享或披露您的信息，但仅限于为了本条款所述之SyncoreOS服务的必需，且该合作方已经与我们签署保密协议或已经签署的合作协议中有明确的保密条款承诺对您的个人信息承担保密责任；
            </p>
            <p>（6）在涉及合并、收购或破产清算时，可能会将您的信息提供、共享或披露给我们的投资方或转让给我们的继承者，届时，我们会再要求我们的投资方或继续者遵守本条款的约定或承担不低于本条款约定的保密责任。</p>
            <p><strong>对收集的个人信息，我们会进行去标识化或匿名化处理</strong>，去标识化是指通过哈希加密、字段替换等方式移除直接标识符，但仍可能结合其他信息重新识别身份；匿名化是指通过泛化、扰动等技术使信息无法关联到特定个人，且不可逆。该类信息为无法重新识别个人信息主体身份的非用户信息，已不属于相关法律中的个人信息的范畴。
            </p>
            <p>如果我们将非个人信息与其他信息结合识别到您的个人身份时，或者与您的个人信息结合使用时，我们会在结合使用期间，将此类信息作为您的个人信息按照本隐私政策对其进行处理和保护。</p>
            <p><strong>当我们提供SyncoreOS服务所需的用户信息使用超出上述范围或者要将收集到的用户信息用于本条款未载明的其他用途，或当我们要将基于特定目的收集而来的信息用于其他目的时，我们会在使用您的个人信息前通知您，并获得您的授权同意。</strong>
            </p>
            <h1 id="5"><strong>五、我们如何保护您的个人信息 </strong></h1>
            <h2 id="5.1">5.1 安全保护措施</h2>
            <p>我们使用多维度的安全保护体系，以防止信息的泄露、丢失、不当使用、未经授权访问和披露等。确保您的个人信息保护处于安全水平，包括技术保护手段、管理制度控制、安全体系保障等诸多方面。</p>
            <p>（1）已实施技术安全保护措施：包括但不限于AES-256 存储加密、去标识化或匿名化处理、访问控制、TLS 1.3 加密通信、双向证书认证等。</p>
            <p>（2）已取得安全认证如：ISO 9001、 ISO 14001 质量管理体系与环境管理体系认证、ISO 21434 道路车辆网络安全工程认证等。</p>
            <p>（3）已建立保障个人信息安全的管理制度、流程和组织。我们也会定期地审查该管理制度、流程和组织，以防未经授权的人员擅自访问、使用或披露用户的信息。</p>
            <p>（4）我们会定期委托第三方机构开展组件漏洞扫描等安全监测，并修复发现的高危漏洞。</p>
            <h2 id="5.2">5.2 安全事件响应</h2>
            <p>若发生个人信息泄露、损毁、丢失等安全事件，我们会启动应急预案，阻止安全事件扩大。安全事件发生后，我们会及时以推送通知、邮件等形式告知您安全事件的基本情况、我们即将或已经采取的处置措施和补救措施，以及我们对您的应对建议。如果难以实现逐一告知，我们将通过公告等方式发布警示。
            </p>
            <h2 id="5.3">5.3 风险提示</h2>
            <p>尽管我们已经采取了这些安全措施，但请注意在互联网上存在固有风险，因此您的信息仍可能被非法访问、非法盗取、非法篡改或毁坏，导致您的合法权益受损，包括但不限于您下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁您的终端设备信息和数据安全等。对此类第三方攻击造成的影响，我们不承担法律责任，请您自行防范。
            </p>
            <h1 id="6"><strong>六、您如何行使个人信息权利</strong></h1>
            <p>鉴于您可能不是本公司的直接客户，您可能需要根据车企的隐私政策，将您的相关请求直接发送给车企，由车企帮助您向我们转达您的请求。我们会在车企承诺向您提供易于操作的用户权利实现机制，向您说明如何行使选择权，如何访问、更正、补充您的用户信息、行使删除权、更改您授权同意的范围等。
            </p>
            <p>我们尊重您对您个人信息的权利。以下列出您依法享有的权利，以及我们将如何保护您的这些权利。</p>
            <h2 id="6.1">6.1 知情权</h2>
            <p>我们通过公布本通知向您告知我们如何处理您的个人信息。我们致力于保障对您信息的使用的透明性。</p>
            <p>（2）访问权</p>
            <p>可以在我们的产品或服务界面中直接查询或访问您的个人信息，包括您可以通过产品页面随时登录您的账号，以访问您账号有关的个人信息。</p>
            <p>您可以通过【设置–用户账号–账户】，访问您的个人信息。如果您无法自行查询或访问您的个人信息，或在行使数据访问权过程中遇到任何问题，您可以通过本通知中披露的方式与我们联络并要求访问您的个人信息。</p>
            <p>（3）更正权</p>
            <p>当您发现我们处理的关于您的个人信息有错误或不完整时，您有权要求我们做出更正或进行补充。您可以通过文末的联系方式提出更正申请。</p>
            <p>（4）删除权</p>
            <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
            <p>(1) 如果我们处理个人信息的行为违反法律法规或与您的约定；</p>
            <p>(2) 如果您不再使用我们的产品或服务，或您注销了车企账号；</p>
            <p>(3) 如果我们的处理目的已实现、无法实现或者为实现处理目的不再必要；</p>
            <p>(4) 如果我们不再为您提供产品或服务，或者保存期限已届满；</p>
            <p>(5) 如果您撤回同意。</p>
            <p>如您基于上述情形请求删除您的敏感个人信息的，您可以随时通过本隐私通知载明的联系方式与我们取得联系，我们将在10个工作日内进行删除。如您基于上述情形请求删除您的一般个人信息的，您可以随时通过本隐私通知载明的联系方式与我们取得联系，我们将在15个工作日作出答复。若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体对您的个人信息进行删除，除非法律法规另有规定或这些实体获得了您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。请您知晓并理解，根据法律法规的规定，如果法律、行政法规规定的保存期限未届满，或者删除个人信息从技术上难以实现的，我们会停止除存储和采取必要的安全保护措施之外的处理。
            </p>
            <p>账户注销权</p>
            <p>我们为您提供账号注销的权利。您可以通过本通知中披露的方式与我们直接联络申请注销您的账号，在您提交账号注销申请后，我们可能需要对您的账号注销进行人工审核以确认您符合账号注销条件，我们将在您提交申请的15个工作日内协助您完成账号的注销工作。在您选择注销账号后，我们将删除或匿名化您在账号下的全部相关个人信息，法律法规另有规定的除外。在您注销后，我们将无法继续向您提供需要使用账号登录的产品或服务。
            </p>
            <p>撤回同意权</p>
            <p>每个业务功能需要一些基本的个人信息才能得以完成（见本通知“<a class="active" @click="scrollToSection('2')">我们如何收集和使用您的个人信息</a>”部分）。</p>
            <p>您可以随时进入车辆系统设置页面的“设置–用户–隐私–隐私设置”以关闭相应权限，从而收回您的授权同意。</p>
            <p>可携权</p>
            <p>当符合国家网信部门规定条件时，您有权请求将个人信息转移至指定的个人信息处理者。在提供正式授权后，您可以通过本通知提供的联系方式实现您的可携权。</p>
            <p>投诉权</p>
            <p>您有权通过本通知中披露的方式联系我们并进行投诉。我们将在收到您投诉之日起15个工作日内做出答复。如果您对我们的答复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、公安、工商等监管部门进行投诉或举报，或向有管辖权法院提起诉讼。
            </p>
            <p>请注意，出于安全考虑，在处理您的请求前，我们可能验证您的身份。对于您合理的请求，我们原则上不收取费用。但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝并在答复中向您具体说明理由。此外，如果您的请求直接涉及国家安全、国防安全、公共卫生、犯罪侦查等和公共利益直接相关的事由，或者可能导致您或者其他个人、组织的合法权益受到严重损害，我们可能无法响应您的请求。
            </p>
            <p>在符合相关法律要求的情况下，您的近亲属可以对您的相关个人信息行使上述查阅、复制、更正、删除等权利，但您另有安排的除外。</p>
            <h1 id="7"><strong>七、我们如何处理未成年人信息</strong></h1>
            <p> &nbsp;
                &nbsp;（1）我们的产品和服务主要面向成年人。若您是18周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您监护人的同意。对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。对于可能涉及的不满14周岁的儿童个人信息，我们除遵守本通知关于用户个人信息的约定外，还会秉持正当必要、知情同意、目的明确、安全保障、依法利用的原则，严格遵循《个人信息保护法》、《儿童个人信息网络保护规定》等法律法规的要求进行儿童个人信息的存储、使用、披露，并保障儿童和其监护人对于相关儿童个人信息的合法权利。
            </p>
            <p> &nbsp; &nbsp;（2）如果我们发现自己在未事先获得可证实的监护人同意的情况下收集了未成年人的个人信息，我们会设法尽快删除相关数据。</p>
            <p> &nbsp; &nbsp;（3）如您为未成年人的监护人，当您对您所监护的未成年人的信息处理存在疑问时，或者您有事实证明未成年人并未取得监护人同意的情况下使用了我们的车内应用程序，请通过下文中的联系方式联系我们。
            </p>
            <h1 id="8"><strong>八、本规则的变更</strong></h1>
            <p>我们的隐私政策会根据业务发展、法律法规变化等原因进行适时调整并重新发布。当隐私政策发生重大变更将通过以下方式通知您：</p>
            <p> &nbsp; &nbsp;（1）在官网显著位置公示；</p>
            <p> &nbsp; &nbsp;（2）提供给车企并要求及时更新系统展示。</p>
            <p>如果您选择继续使用系统或系统服务，则视为您接受对本政策相关条款所做的调整或变更。如果您不同意本条款的内容，请您务必及时联系车企或我们，按照指导进行进一步的操作。</p>
            <h1 id="9"><strong>九、如何联系我们 </strong></h1>
            <p>我们指定了<strong>用户权益事务联系人，</strong>邮箱地址为：privacy@syncore.space</p>
            <p>如果您对本条款有任何疑问，行使数据主体权利或个人信息保护的投诉举报，或需要联系用户权益事务联系人，您还可以通过以下联系方式与我们联系：</p>
            <p>（1）<strong>联系电话:</strong> &nbsp;(0551) 6515 7417（工作日 9:00-18:00)</p>
            <p>（2）<strong>邮寄地址</strong>：广东省广州市海珠区琶洲大道79-87号宝地广场 22 楼星河智联汽车科技有限公司，邮政编码：510335</p>
            <p>（3）<strong>问题反馈:</strong> &nbsp; <el-button @click="toConsultation" type="text"
                    style="font-size: 15px;">点我跳转</el-button></p>
            <p><br></p>
            <p>一般情况下，我们将在十五个工作日内回复，但法律法规另有规定的除外。如果您对我们的回复不满意，特别是认为我们的个人信息处理行为损害了您的合法权益时，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报，或者向有管辖权的法院提起诉讼。
            </p>
            <p><br></p>
            <p>本隐私政策于2025年9月9日更新并生效。</p>
            <p><br></p>
        </div>


    </div>
</template>
  
<script>
import NavItem from '../components/NavItem.vue'; // 导入递归组件
export default {
    name: 'Home',
    components: {
        NavItem
    },
    data() {
        return {
            isClicking: false,   // 是否正在处理点击事件
            activeSection: '0', // 当前高亮的导航项
            navList: [
                {
                    id: '0', title: '星河智联个人信息保护政策V1.0', children: [{
                        id: '0.1', title: '尊敬的用户：'
                    }]

                },
                { id: '1', title: '一、我们是谁' },

                {
                    id: '2', title: '二、我们如何收集和使用您的个人信息',
                    children: [
                        {
                            id: '2.1', title: '2.1 个人信息收集说明',
                            children: [{
                                id: '2.1.1', title: '2.1.1 补充说明'
                            }],
                        },
                        { id: '2.2', title: '2.2 设备权限获取说明', }]
                },
                {
                    id: '3', title: '三、我们如何存储您的个人信息',
                    children: [
                        { id: '3.1', title: '3.1 存储方式和期限' },
                        { id: '3.2', title: '3.2 存储地域', }]
                },
                { id: '4', title: '四、我们如何共享、转让、公开您的个人信息' },
                {
                    id: '5', title: '五、我们如何保护您的个人信息',
                    children: [
                        { id: '5.1', title: '5.1 安全保护措施 ' },
                        { id: '5.2', title: '5.2 安全事件响应' },
                        { id: '5.3', title: '5.3 风险提示' },
                    ]
                },
                {
                    id: '6', title: '六、您如何行使个人信息权利',
                    children: [
                        { id: '6.1', title: '6.1 知情权' },
                    ]
                },
                { id: '7', title: '七、我们如何处理未成年人信息' },
                { id: '8', title: '八、本规则的变更' },
                { id: '9', title: '九、如何联系我们' },


            ],
            sections: [
                { id: 'section1', title: '第一部分', content: '这是第一部分的内容...' },
                { id: 'section2', title: '第二部分', content: '这是第二部分的内容...' },
                { id: 'section3', title: '第三部分', content: '这是第三部分的内容...' },
                { id: 'section4', title: '第三部分', content: '这是第三部分的内容...' },
                { id: 'section5', title: '第三部分', content: '这是第三部分的内容...' },
                { id: 'section6', title: '第三部分', content: '这是第三部分的内容...' },
                { id: 'section7', title: '第三部分', content: '这是第三部分的内容...' },
                { id: 'section8', title: '第三部分', content: '这是第三部分的内容...' },
                { id: 'section9', title: '第三部分', content: '这是第三部分的内容...' },
            ],
        }
    },
    methods: {
        toConsultation() {
            this.$router.push('/consultation')
        },
        handleNavigate(id) {
            // 点击导航项时的处理逻辑，比如滚动到对应的内容区域
            const target = document.getElementById(id);
            if (target) {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },
        scrollToSection(id) {
            this.isClicking = true; // 标记正在点击
            this.activeSection = id; // 手动设置高亮

            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }

            // 延迟恢复滚动监听
            setTimeout(() => {
                this.isClicking = false;
            }, 1000); // 根据滚动动画时间调整此值

            // 自动滚动左侧导航栏
            //   this.scrollSidebarToActive();
        },
        handleScroll() {
            if (this.isClicking) return; // 如果正在点击，则不处理滚动事件

            // const sections = this.sections.map((section) => {
            //     const element = document.getElementById(section.id);
            //     const rect = element.getBoundingClientRect();
            //     return { id: section.id, top: rect.top };
            // });
            let sections = []
            const pushItem = (arr) => {
                arr.map(item => {
                    const element = document.getElementById(item.id);
                    const rect = element.getBoundingClientRect();
                    sections.push(
                        { id: item.id, top: rect.top }
                    )
                    if (item.children) {

                        pushItem(item.children)
                    }
                })


            }
            pushItem(this.navList)
            // 找到距离顶部最近的 section
            const currentSection = sections.find((section) => section.top > 0) || sections[sections.length - 1];

            if (currentSection) {
                this.activeSection = currentSection.id;

                // 自动滚动左侧导航栏
                this.scrollSidebarToActive();
            }

        },
        scrollSidebarToActive() {
            // 获取当前高亮的导航项
            const activeNav = document.querySelector('.sidebar .active');
            const sidebar = document.querySelector('.sidebar');

            if (activeNav && sidebar) {
                const navRect = activeNav.getBoundingClientRect(); // 高亮项的位置
                const sidebarRect = sidebar.getBoundingClientRect(); // 左侧导航栏的位置

                // 检查高亮项是否超出可视范围
                if (navRect.top < sidebarRect.top) {
                    // 如果高亮项在可视区域上方，向上滚动
                    sidebar.scrollTop -= sidebarRect.top - navRect.top + 10; // 加 10 是为了稍微留点空间
                } else if (navRect.bottom > sidebarRect.bottom) {
                    // 如果高亮项在可视区域下方，向下滚动
                    sidebar.scrollTop += navRect.bottom - sidebarRect.bottom + 10; // 加 10 是为了稍微留点空间
                }
            }
        },
    },

    mounted() {
        // 监听滚动事件
        const content = document.querySelector('.content');
        content.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        // 移除滚动事件监听
        const content = document.querySelector('.content');
        content.removeEventListener('scroll', this.handleScroll);
    },

}
</script>
  
<style  lang="scss" scoped>
// .home {
//     padding: 80px;

//     .left,
//     .right {
//         height: 100%;
//         overflow-y: auto;
//     }
// }

.container {
    display: flex;
    height: 100vh;
    padding: 60px 20px;
}

.sidebar {
    width: 345px;
    padding: 20px;
    padding-left: 0;
    border-right: 1px solid #ddd;
    overflow-y: auto;
    height: 100%;
}

.sidebar ul {
    list-style: none;
    padding: 0;
}

.sidebar li {
    margin-bottom: 200px;
}

.content {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    height: 100%;
}

.section {
    margin-bottom: 150px;
}

.section h2 {
    margin: 0 0 10px 0;
}

.active {
    // font-weight: bold;
    color: #007bff;
}

.content {

    div,
    p,
    li,
    ul,
    span,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    h7 {
        line-height: 1.7;
    }
}
table {
  width: 100%; /* 表格宽度占满父容器 */
  border-collapse: collapse; /* 合并单元格边框 */
  margin: 20px 0; /* 表格上下的外边距 */
  font-size: 14px; /* 字体大小 */
  color: #333; /* 字体颜色 */
  text-align: left; /* 左对齐 */
  background-color: #fff; /* 表格背景色 */
  table-layout: auto; /* 自动调整列宽 */
}

table th,
table td {
  border: 1px solid #ddd; /* 单元格边框 */
  padding: 10px 15px; /* 单元格内边距 */
  vertical-align: top; /* 垂直方向顶部对齐 */
}

table th {
  background-color: #f9f9f9; /* 表头背景色 */
  font-weight: bold; /* 表头字体加粗 */
  white-space: nowrap; /* 禁止换行 */
}

// table tr:nth-child(even) {
//   background-color: #f5f5f5; /* 奇偶行不同背景色 */
// }

table tr:hover {
  background-color: #f1f1f1; /* 鼠标悬停时的背景色 */
}

</style>
  